<template>
  <div>
  <div class="flex flex-wrap items-center flex-col-reverse md:flex-col">
    <div class="w-full mb-3 bg-red-100 border-red-400 border h-20">
      {{ $t('Not Me') }}
      <ul :list="nopearray" class="p-4">
        <li v-for="(choice, index) in nopearray" class="inline-block mb-0 mx-1 overflow-hidden text-center bg-white rounded shadow w-24">
            <span class="block align-middle cursor-move">
              <span class="align-middle text-xs">{{ choice.attributes['title'].text }}</span>
            </span>
        </li>
        <li v-if="!nopearray.length">{{ $t('Add a Pattern that is Not you here!') }}</li>
      </ul>
    </div>
    <div class="comparison-wrapper py-3">
      <div class="comparison-responsive">       
          <div v-for="card in cards" key="card" class="comparison-item mb-1 mr-2 relative" v-bind:class="{active: leftChosen}">
            <vue-swing
              @throwoutup="onUpThrowout"
              :config="config"
              ref="vueswing"
            > 
            <div class="flex-grow h-full align-middle">
              <div class="attributes">
                <div v-if="!cards.length">{{ $t('Add a Pattern that is Maybe you here!') }}</div>
                <div v-on:click="notMe" class="bg-red-300 cursor-pointer">
                  {{ $t('Not Me') }}
                </div>
                  <div class="flex-1 flex flex-col flex-grow even:bg-gray-200 justify-center relative" v-for="attributes in card.attributes">
                    <span class="label container">{{ attributes.label }}</span>
                    <span class="description" v-html="attributes.text"></span>
                  </div>
              </div>
            </div>
            </vue-swing>
          </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import VueSwing from 'vue-swing'
import draggable from 'vuedraggable'

  export default {
        components: {
          draggable,
          VueSwing
        },
        props: {
            array: '',
            route:'',
        },
        data() {
          return {
            leftChosen: false,
            rightChosen: false,
            cards: this.array,
            nopearray: [],
            config: {
              allowedDirections: [
                VueSwing.Direction.UP
              ],
              maxRotation: 0,
              minThrowOutDistance: 250,
              maxThrowOutDistance: 300
            },
          }
        },
        methods: {
            notMe: function (event) {
                    // When clicked, this should add this notMe to nopearray
                    this.cards.push(this.nopearray);
            },
            add () {
              this.cards.push(`${this.cards.length + 1}`)
            },
            remove () {
              this.swing()
              setTimeout(() => {
                this.cards.pop()
              }, 1)
            },
            swing () {
              const cards = this.$refs.vueswing.cards
              cards[cards.length - 1].throwOut(
                Math.random() * 100 - 50,
                Math.random() * 100 - 50
              )
            },
            onUpThrowout ({ target, throwDirection }) {
                  target.cards.remove
                console.log(`Not Me ${target.textContent}!`)
            },
            onRightThrowout ({ target, throwDirection }) {
              console.log(`Maybe Me ${target.textContent}!`)
            },
            submitRight: function (event) {
              $( "#submitRight").addClass( "loading" );
              axios.put(this.route, { 
                results: [this.itemsarray[1].id]
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            }
              
          }
      
      };
</script>
